import { useDispatch, useSelector } from "@/store";
import { SiteSearchScope, closeSiteSearch, openSiteSearch } from "@/store/reducers/siteSearch";

export const useSiteSearch = () => {
  const dispatch = useDispatch();
  const { open: isOpen, scope, term } = useSelector((s) => s.siteSearch);

  return {
    isOpen,
    scope,
    term,
    open: (options?: { scope?: SiteSearchScope; term?: string }) =>
      dispatch(openSiteSearch(options)),
    close: () => dispatch(closeSiteSearch()),
  };
};
